import { useMediaQuery } from '~/hooks/useMediaQuery';
import { DesktopLayout } from './DesktopLayout';
import { MobileLayout } from './MobileLayout';
import { useAppProcessing } from '../context';
import { BreadcrumbItem } from '~/utils';

export const ApplicationDetailsLayout = () => {
  const { isUltraWide, isWide, isNormal, isNarrow, isUltraNarrow, isMobile } = useMediaQuery();
  const { application } = useAppProcessing();
  const breadcrumbItems: BreadcrumbItem[] = [
    {
      href: '/applications',
      label: 'Applications',
    },
    {
      href: `/applications/${application.id}`,
      label: `Application Details ${application.humanReadableId}`,
    },
  ] as BreadcrumbItem[];

  if (isUltraWide || isWide || isNormal) {
    return <DesktopLayout programDetailsLineSplit={false} breadcrumbItems={breadcrumbItems} />;
  }

  if (isNarrow || isUltraNarrow) {
    return <DesktopLayout programDetailsLineSplit={true} breadcrumbItems={breadcrumbItems} />;
  }

  if (isMobile) {
    return <MobileLayout breadcrumbItems={breadcrumbItems} />;
  }

  // should not reach here
  return null;
};
